@if (title()) {
  <p class="progress-bar__title">{{ title() }}</p>
}

<mat-progress-bar class="rp-progress-bar" [class]="'rp-progress-bar__' + progressColor()" [mode]="mode()" [value]="value()" />
